import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";
import {
  FormValidations,
  SetValidationRuleFunction,
  ValidationActionType,
} from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";

export const overviewFormValidations = (
  actualCustomerNumber?: string
): FormValidations => {
  return {
    referralCustomerCode: {
      type: "Function",
      validate: (value) =>
        validateReferralCustomerCode(value, actualCustomerNumber),
      message: actualCustomerNumber
        ? "overviewFormValidation.referralCustomerCodeLogged"
        : "overviewFormValidation.referralCustomerCodeNew",
    } as FunctionValidationRule,
  };
};

export const setConsentsValidations = (
  consents: UserEnumDTO[],
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  const rule: FunctionValidationRule = {
    type: "Function",
    validate: (value: any) => value === true || value === false,
    message: "required",
  };

  for (const consent of consents) {
    setValidationRule(`consents.${consent.code}`, rule, action);
  }
};

function validateReferralCustomerCode(
  referralCustomerCode: string | undefined,
  actualCustomerNumber?: string
): boolean {
  if (!referralCustomerCode) {
    return true;
  }

  if (
    typeof referralCustomerCode !== "string" ||
    referralCustomerCode.length !== 10 ||
    !/^[0-9]+$/.test(referralCustomerCode)
  ) {
    return false;
  }

  if (actualCustomerNumber && referralCustomerCode === actualCustomerNumber) {
    return false;
  }

  return true;
}
